import { Container, Button } from '@mantine/core';
import classes from './HeaderSimple.module.css';

export function HeaderSimple() {
  // Function to scroll to the contact form
  const scrollToContact = () => {
    // Find the contact form element by its specific ID
    const contactForm = document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <header className={classes.header}>
      <Container size="md" className={classes.inner}>
        <div className={classes.logo}>
          <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>SmartMenu</span>
        </div>
        <Button
          onClick={scrollToContact}
          variant="filled"
          color="green"
          size="sm"
        >
          お問い合わせ
        </Button>
      </Container>
    </header>
  );
} 